// Shared team-logo renderer used by Yesterday/Today/Tomorrow and the
// Standings tab. Pulls the SVG straight from NCAA.com's CDN using the
// hyphen-cased slug the scoreboard proxy emits — same slug form the
// games table and standings response carry, so no normalization is
// needed. Broken slugs (teams NCAA has not published a logo for) hide
// themselves via the <img> onError handler so row rhythm stays clean.

// logoURL returns the NCAA.com SVG URL for a team slug.
export function logoURL(slug: string): string {
  return `https://www.ncaa.com/sites/default/files/images/logos/schools/bgl/${slug}.svg`;
}

export function TeamLogo({ slug, alt }: { slug: string; alt: string }) {
  if (!slug) return null;
  return (
    <img
      src={logoURL(slug)}
      alt={alt}
      className="team-logo"
      loading="lazy"
      onError={(e) => {
        (e.currentTarget as HTMLImageElement).style.visibility = "hidden";
      }}
    />
  );
}
